import { render, staticRenderFns } from "./WarehouseExports.vue?vue&type=template&id=8010f8ba&"
import script from "./WarehouseExports.vue?vue&type=script&lang=ts&"
export * from "./WarehouseExports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports